const buildCalibrationPanelId = (calibrationId: string): string => `calibration-${calibrationId}`;

export default buildCalibrationPanelId;
